import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import asapPreparationTimeSelector from 'selectors/asapPreparationTimeSelector';

export const deliveryTimeTypeAsapHOC = compose(
  connect((state, { deliveryType, deliveryConditions }) => ({
    preparationTime: asapPreparationTimeSelector(state, {
      deliveryType,
      deliveryConditions,
    }),
  })),
  withProps(({ deliveryType, preparationTime }) => ({
    estimateText: {
      [true]: `Arrives under ${preparationTime} minutes`,
      [deliveryType ===
      'PICKUP']: `Approx. ${preparationTime} minutes after your order is placed`,
    }.true,
  })),
);
